<template>
    <div>
        <el-dialog :title='diagtitle' :visible.sync='companydiag' :close-on-click-modal='false'
                   :close-on-press-escape='false' width='900px' v-dialogDrag>
            <taxform :Formlist='Formlist' :column='2' @getdata='getdata' :formdata='formdata' ref='taxform'
                     @inputchange='inputchange'></taxform>
            <span slot='footer' class='dialog-footer'>
			   <el-button type='primary' @click='forsubmit'>保存</el-button>
			    <el-button @click='companydiag=false'>取消</el-button>
			  </span>
        </el-dialog>
        <div class='areatable'>
            <div style='margin-bottom: 20px;' class='between-space'>
                <el-button type='primary' @click='foradd'>新增公司</el-button>
                <el-input style='width: 200px;' prefix-icon='el-icon-search' @input='forserch' v-model='likeserch'
                          placeholder='请输入税号,名称,联系人,手机,手机号'></el-input>
            </div>
            <div class='tableh'>
                <el-table :data='tableData' border :height='tableHeight' ref='multipleTable'>
                    <el-table-column prop='qiybh' label='企业代码' align='center'>
                    </el-table-column>
                    <el-table-column prop='name' label='纳税人名称' align='center'>
                    </el-table-column>
                    <el-table-column prop='englishName' label='英文名称' align='center'>
                    </el-table-column>
                    <el-table-column prop='japaneseName' label='日文名称' align='center'>
                    </el-table-column>
                    <el-table-column prop='taxNumber' label='纳税人识别号' align='center'>
                    </el-table-column>
                    <el-table-column prop='' label='是否启用数字税务账户' align='center'>
                        <template slot-scope='scope'>
                            <div v-if="scope.row.digitalStatus=='0'">否</div>
                            <div v-if="scope.row.digitalStatus=='1'">是</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop='' label='启用状态' align='center'>
                        <template slot-scope='scope'>
                            <div v-if="scope.row.state=='0'">正常</div>
                            <div v-if="scope.row.state=='1'">停用</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop='' label='操作' align='center'>
                        <template slot-scope='scope'>
                            <div class='Centerupdown'>
                                <el-button @click='forsee(scope.row)' type='text' size='small'>查看</el-button>
                                <el-button type='text' size='small' @click='forupdate(scope.row)'>编辑</el-button>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <div class='buttompage '>
                <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange'
                               :page-sizes='pwm.limits' :page-size='pwm.limit' :current-page='pwm.page'
                               layout='total, sizes, prev, pager, next, jumper' :key='elementui_page_component_key'
                               :total='pwm.count'>
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { addCompany, getCompanyList, updateCompany } from '../../../api/home.js';

export default {
    components: {},
    data() {
        return {
            likeserch: '',
            pwm: {
                count: 0,
                limit: 100,
                page: 1,
                limits: [50, 100, 200, 500]
            },
            elementui_page_component_key: '',
            searchlist: {},
            tableData: [
                {}
            ],
            tableHeight: '',
            isshou: true,
            companydiag: false,
            diagtitle: '',
            formdata: {
                qiybh: '',
                code: '',
                bankAccount: '',
                type: '',
                taxNumber: '',
                name: '',
                addressPhone: '',
                contact: '',
                email: '',
                position: '',
                name2: '',
                sort: '',
                digitalStatus: '',
                englishName: '',
                japaneseName: ''
            },
            Formlist: [
                {
                    prop: 'qiybh',
                    label: '企业编号',
                    type: 'input',
                    disabled: true
                },
                {
                    prop: 'code',
                    label: '公司代码',
                    type: 'input',
                    isnotnull: true,
                    inputchange: true
                },
                {
                    prop: 'bankAccount',
                    label: '开户行及账号',
                    type: 'input',
                    isnotnull: true
                },
                {
                    prop: 'type',
                    label: '纳税人类型',
                    type: 'select',
                    isnotnull: true,
                    selectval: [{
                        label: '小规模纳税人',
                        value: '1'
                    },
                        {
                            label: '一般纳税人',
                            value: '0'
                        }
                    ]
                },
                {
                    prop: 'taxNumber',
                    label: '纳税人识别号',
                    type: 'input',
                    isnotnull: true,
                    inputchange: true
                },
                {
                    prop: 'name',
                    label: '纳税人名称',
                    type: 'input',
                    isnotnull: true
                },
                {
                    prop: 'englishName',
                    label: '英文名称',
                    type: 'input'
                },
                {
                    prop: 'japaneseName',
                    label: '日文名称',
                    type: 'input'
                },
                {
                    prop: 'addressPhone',
                    label: '地址、电话',
                    type: 'input',
                    isnotnull: true
                },
                {
                    prop: 'contact',
                    label: '联系人',
                    type: 'input'
                },
                {
                    prop: 'email',
                    label: '邮箱',
                    type: 'input'
                },
                {
                    prop: 'position',
                    label: '备注',
                    type: 'input'
                },
                {
                    prop: 'digitalStatus',
                    label: '是否启用数字税务账户',
                    type: 'select',
                    isnotnull: true,
                    selectval: [
                        {
                            label: '是',
                            value: '1'
                        },
                        {
                            label: '否',
                            value: '0'
                        },
                        
                    ]
                }
            ]
        };

    },
    created() {
        this.getCompanyList();
    },
    mounted() {
        this.repairtable();
    },
    methods: {
        inputchange(e) {
            if (e.prop == 'code') {
                this.formdata.code = e.value;
            }
            if (e.prop == 'taxNumber') {
                this.formdata.taxNumber = e.value;
            }

            if (this.notemptyandnull(this.formdata.code) & this.notemptyandnull(this.formdata.taxNumber)) {
                this.formdata.qiybh = this.formdata.code + this.formdata.taxNumber;
                this.$forceUpdate();
            }

        },
        forserch() {
            this.elementui_page_component_key++;
            this.getCompanyList();
        },
        getCompanyList() {
            let currentUser = JSON.parse(localStorage.getItem('useropj'));
            var param = {
                groupId: currentUser.companyGroupId,
                likeSearch: this.likeserch
            };
            this.pwm.param = param;
            getCompanyList(this.pwm).then(res => {
                this.tableData = res.data.data;
                this.pwm.count = res.data.count;
            });
        },
        handleSizeChange() {
            this.pwm.limit = val;
            this.getCompanyList();
        },
        handleCurrentChange() {
            this.pwm.page = val;
            this.getCompanyList();
        },
        foradd() {
            Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
            this.diagtitle = '新增公司';
            this.Formlist.forEach(item => {
                // 设置所有字段为可编辑状态
                item.disabled = false;
                // 特殊处理：企业编号字段设置为只读
                if (item.label == '企业编号') {
                    item.disabled = true;
                }
            });
            this.companydiag = true;

            this.$refs.taxform.clearValidate();
        },
        forsee(row) {
            this.formdata = JSON.parse(JSON.stringify(row));
            this.Formlist.forEach(item => {
                item.disabled = true;
            });
            this.diagtitle = '查看公司';
            this.companydiag = true;
        },
        forupdate(row) {
            this.formdata = JSON.parse(JSON.stringify(row));
            this.diagtitle = '编辑公司';
            this.Formlist.forEach(item => {
                // 设置所有字段为可编辑状态
                item.disabled = false;
                // 特殊处理：企业编号字段设置为只读
                if (item.label == '企业编号') {
                    item.disabled = true;
                }
            });
            this.companydiag = true;
        },
        forsubmit() {
            this.$refs.taxform.submitForm();
        },
        getdata(data) {
            this.formdata = data;
            this.formdata.groupId = JSON.parse(localStorage.getItem('useropj')).companyGroupId;
            this.formdata.qiybh = this.formdata.taxNumber + this.formdata.code;
            this.formdata.state = '0'
            if (this.diagtitle == '新增公司') {
                addCompany(this.formdata).then(res => {
                    if (res.data.success) {
                        this.$message.success('新增成功');
                        this.getCompanyList();
                        this.companydiag = false;
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            } else if (this.diagtitle == '编辑公司') {
                updateCompany(this.formdata).then(res => {
                    if (res.data.success) {
                        this.$message.success('编辑成功');
                        this.getCompanyList();
                        this.companydiag = false;
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            }
        },
        changeshou() {
            this.isshou = !this.isshou;
        },
        repairtable() {
            this.$nextTick(() => {
                this.tableHeight = this.diagheightshenghe();
                setTimeout(() => {
                    this.$refs.multipleTable.doLayout();
                }, 300);
                window.onresize = () => {
                    this.tableHeight = this.diagheightshenghe();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 300);
                };
            });
        }
    }
};
</script>

<style scoped lang='less'>
/* 	弹框底部确认按钮 */
.buttomanniu:extend(.end-flex) {
    margin-top: 30px;
}

.buttomanniu > div:nth-of-type(1):extend(.Centerhorizontally) {
    width: 93px;
    height: 32px;
    background: #0080FF;
    border-radius: 2px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    color: #FFFFFF;
}

.buttomanniu > div:nth-of-type(2):extend(.Centerhorizontally) {
    width: 91px;
    height: 30px;
    border-radius: 2px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    margin-left: 53px;
    color: #333333;
    border: 1px solid #999999;
}

/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
    width: 100%
}

.zw {
    width: 400px;
    margin-top: -18px;
    margin-left: 20px;
}

/deep/ .el-input--suffix .el-input__inner {
    padding-right: 15px;
}

.top-line {
    display: flex;
    align-items: center;
}

/deep/ .el-form-item__label {
    display: flex;
    justify-content: center;
    padding-left: 10px;
}

.topprocess {
    background: #FDFDFD;
    padding-top: 16px;
}

.minheight {
    height: 50px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.maxheight {
    height: 300px;
    transition: all 0.3s ease;
}

/deep/ .el-select {
    width: 100%;
}
</style>
